import UserError from './UserError.js'

export class CheckUserEmailExistsUserError extends UserError {}
